const ABORT_ERROR_MESSAGE = 'The user aborted a request.';

const isAbortError = (error: unknown): boolean => {
	if (typeof error === 'string') {
		return error === ABORT_ERROR_MESSAGE || error.startsWith('AbortError:');
	}

	if (!error || typeof error !== 'object') {
		return false;
	}

	const candidate = error as { name?: string, message?: string };

	return candidate.name === 'AbortError' ||
		candidate.message === ABORT_ERROR_MESSAGE ||
		candidate.message?.startsWith('AbortError:') === true;
};

export default isAbortError;
